import React, {useEffect, useState} from "react";
import {Navigate} from "react-router-dom";
import {useUser} from "@/contexts/UserContext";
import ApiInterface from "@/commons/api/ApiInterface";

// Esempio: "user.admin.page.logs"
type Props = {
    permission: string;
    fallback: string;
    element: React.ReactElement;
};

type PermissionType = boolean | undefined;

const ProtectedRoute: React.FC<Props> = ({permission, fallback, element}) => {
    const {accountData, userLoadingComplete} = useUser();
    const [hasPermission, setHasPermission] = useState<PermissionType>(undefined);

    useEffect(() => {
        if(!userLoadingComplete) return;

        if(accountData != undefined){
            ApiInterface.hasPermission(permission).then(r => {
                setHasPermission(r);
            })
        }else {
            setHasPermission(false);
        }

    }, [userLoadingComplete]);

    if (hasPermission === undefined) {
        return null; // oppure uno spinner
    }

    //false
    if (!hasPermission) {
        return <Navigate to={fallback} replace />;
    }

    //true
    return element;
};

export default ProtectedRoute;
